// Recorded clinical receipt bundles for the Veralta Overview hero.
//
// Two REAL sealed prior-authorization packages produced by
// scripts/generate-clinic-receipts.ts (stub model + in-process witness), inlined
// at build like apps/demo/src/data.ts does for the Torbridge invoices. Both are
// witnessed + policy-bound and differ only in the conformance verdict:
//   prior-auth-conformant — payer on the allowlist  -> conformant: true
//   prior-auth-violation  — payer off the allowlist -> conformant: false
import priorAuthConformant from "../../../demo-artifacts-clinic/receipts/prior-auth-conformant/bundle.json";
import priorAuthViolation from "../../../demo-artifacts-clinic/receipts/prior-auth-violation/bundle.json";

export type Bundle = Record<string, string>;

// Keyed by the bundleId each hero card references.
export const CLINIC_BUNDLES: Record<string, Bundle> = {
  "prior-auth-conformant": priorAuthConformant as Bundle,
  "prior-auth-violation": priorAuthViolation as Bundle
};
